import { compose } from 'recompose';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Creators as ProductCreators } from '../../../store/ducks/product';

class SendEmail extends Component {

  componentDidMount() {
    this.props.sendEmailProducts(this.props);
  }

  render() {
    return (
      <div>Também enviei esta lista para o seu email 😉. Como você <b>avalia</b> o meu atendimento virtual ?</div>
    )
  }
}

export default compose(
  connect(null, {
    ...ProductCreators
  })
)(SendEmail);